'use strict';

angular.module('mean.general-tasks').controller('CombinationController', ['$scope', 'Global', 'CombinationService', 'toaster', 'ngDialog',
  function ($scope, Global, CombinationService, toaster, ngDialog) {

    $scope.global = Global;
    $scope.combinationLists = [];
    $scope.formValue = { projectType: '', geoLocation: '' };
    $scope.isValidEntry = false;

    $scope.init = () => {
      CombinationService.query({ type: 'adminQuey'}, (results) => {
        $scope.combinationLists = results;
      });
    }

    $scope.submitForm = () => {
      var found = $scope.combinationLists.filter(item => (item.projectType === $scope.formValue.projectType && item.geoLocation === $scope.formValue.geoLocation));
      if (!found.length && $scope.isValidEntry) {
        var combination = new CombinationService({
          projectType: $scope.formValue.projectType,
          geoLocation: $scope.formValue.geoLocation
        });
        combination.$save((result) => {
          (result) && $scope.combinationLists.push(result) && ($scope.formValue = {});
        })
      }
    }

    $scope.checkDuplicates = () => {
      var isExist = $scope.combinationLists.filter(item => (item.projectType === $scope.formValue.projectType && item.geoLocation === $scope.formValue.geoLocation));
      $scope.isValidEntry = !isExist.length
      return !isExist.length;
    }

    $scope.deleteCombination = (combination, indexNo) => {
      ngDialog.openConfirm({
        template:
          '<h2>Delete Combination</h2>' +
          '<p>This operation will delete combination from the system</p>' +
          '<p>Are you sure you want to continue? </p>' +
          '<div>' +
          '<button type="button" class="btn btn-default" ng-click="closeThisDialog(0)">No&nbsp;' +
          '<button type="button" class="btn btn-primary m-left-10" ng-click="confirm(1)">Yes' +
          '</button></div>',
        plain: true,
        className: 'ngdialog-theme-default ngdialg-padding',
        closeByDocument: false,
        closeByEscape: false,
      }).then(function (value) {
        combination.$delete(function (success) {
          $scope.combinationLists.splice(indexNo, 1);
          toaster.pop('success', 'Combination Deleted successfully.');
        }, function (error) {
          toaster.pop('error', 'Error', error);
        });

      }, function (value) { });
    }
  }

]);



// WEBPACK FOOTER //
// ./packages/custom/general-tasks/public/controllers/combinations.js